// Vendors
import React, { useState } from 'react';
import axios from 'axios';

const CreatePdf = ({ projectID, builderMeta, _isSubscribed }) => {
  const [loading, setLoading] = useState('');

  const handleCreatePDF = (type) => {
    if (!type) return false;

    _isSubscribed = true;
    setLoading(type);

    const formData = new FormData();
    formData.append('action', 'wl_pip_create_pdf');
    formData.append('type', type);
    formData.append('pid', projectID);
    formData.append('bid', builderMeta.ID);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { builderMeta, projectMeta, pdfData }
          }
        }) => {
          if (success && _isSubscribed) {
            setLoading('');
            _isSubscribed = false;

            const pdfObject = `<object width="100%" height="100%" data="data:application/pdf;base64,${pdfData}" type="application/pdf" class="internal"><embed src="data:application/pdf;base64,${pdfData}" type="application/pdf" /></object>`;
            const docTitle =
              type === 'builder'
                ? `${builderMeta.first_name} ${builderMeta.last_name}`
                : projectMeta.address;

            let newPDFWindow = window.open('#', '_blank');
            newPDFWindow.document.write(`<html>
            <head>
              <title>${docTitle}</title>
            </head>
            <body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">
              ${pdfObject}
            </body>
          </html>`);
          }
        }
      )
      .catch((error) => {
        console.log(error);
        _isSubscribed = false;
        setLoading('');
      });
  };

  return (
    <div className="grid__col-xs-12 u--margin-bottom-30">
      <p className="u--margin-0">
        <button
          className={`btn btn--link btn--create-pdf ${
            loading === 'builder' ? 'btn--create-pdf--loading' : ''
          }`}
          onClick={() => handleCreatePDF('builder')}
        >
          <span className="icon perc-icon-file-pdf" /> Builder Info
        </button>
        <button
          className={`btn btn--link btn--create-pdf ${
            loading === 'project' ? 'btn--create-pdf--loading' : ''
          }`}
          onClick={() => handleCreatePDF('project')}
        >
          <span className="icon perc-icon-file-pdf" /> Project Info
        </button>
      </p>
    </div>
  );
};

export default CreatePdf;
